module.exports = __webpack_public_path__ + "img/jonathan.25e62d69.svg";